var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiskGptSendEnabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#D93954"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.08 15.5047L16.576 9.98472C16.48 9.88872 16.432 9.77139 16.432 9.63272C16.432 9.49405 16.48 9.37672 16.576 9.28072C16.672 9.18472 16.7893 9.13672 16.928 9.13672C17.0667 9.13672 17.184 9.18472 17.28 9.28072L24 16.0007L17.28 22.7207C17.184 22.8167 17.0667 22.8647 16.928 22.8647C16.7893 22.8647 16.672 22.8167 16.576 22.7207C16.48 22.6247 16.432 22.5074 16.432 22.3687C16.432 22.2301 16.48 22.1127 16.576 22.0167L22.08 16.4967H8.496C8.35733 16.4967 8.24 16.4487 8.144 16.3527C8.048 16.2567 8 16.1394 8 16.0007C8 15.8621 8.048 15.7447 8.144 15.6487C8.24 15.5527 8.35733 15.5047 8.496 15.5047H22.08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskGptSendEnabled);
export default __webpack_public_path__ + "static/media/risk-gpt-send-enabled.15b05ce8324cdda20951c6b061b70ff3.svg";
export { ForwardRef as ReactComponent };